import { Skeleton } from "@mui/material";
import styled from "styled-components";

export const DateSkeleton = styled(Skeleton).attrs({
  height: 18,
  width: 80,
})`
  border-radius: 4px;
`;

export const CardSkeletonContainer = styled.div`
  padding: 16px;
  margin-bottom: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fff;
`;

export const CardHeaderSkeleton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

export const StatusSkeleton = styled(Skeleton).attrs({
  height: 24,
  width: 60,
})`
  border-radius: 12px;
`;

export const TitleSkeleton = styled(Skeleton).attrs({
  height: 20,
  width: "70%",
})`
  border-radius: 4px;
  margin-bottom: 8px;
`;

export const SubtitleSkeleton = styled(Skeleton).attrs({
  height: 16,
  width: "90%",
})`
  border-radius: 4px;
  margin-bottom: 8px;
`;

export const UserSkeleton = styled(Skeleton).attrs({
  height: 14,
  width: "50%",
})`
  border-radius: 4px;
`;
